var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMosaicIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1049 1.89538C17.5519 1.64491 16.8839 1.67117 16.3598 1.96479L13.0007 3.85422V3.80769C13.0007 1.70838 10.9816 0 8.50044 0H4.50023C2.0191 0 0 1.70838 0 3.80769V7.19231C0 9.29162 2.0191 11 4.50023 11H8.50044C10.9816 11 13.0007 9.29162 13.0007 7.19231V7.14578L16.3598 9.03521C16.6439 9.19514 16.9719 9.27552 17.2999 9.27552C17.5749 9.27552 17.8519 9.21885 18.104 9.10462C18.657 8.85416 19 8.36764 19 7.8371V3.16378C19.001 2.6324 18.658 2.14584 18.1049 1.89538ZM12.0006 7.19231C12.0006 8.82538 10.4305 10.1538 8.50044 10.1538H4.50023C2.57013 10.1538 1.00005 8.82538 1.00005 7.19231V3.80769C1.00005 2.17462 2.57013 0.846154 4.50023 0.846154H8.50044C10.4305 0.846154 12.0006 2.17462 12.0006 3.80769V7.19231ZM18.0009 7.83622C18.0009 8.05791 17.8629 8.25338 17.6319 8.3583C17.4009 8.46322 17.1319 8.45307 16.9139 8.32953L13.0007 6.12868V4.86962L16.9129 2.66876C17.1319 2.54607 17.4009 2.53507 17.6319 2.64C17.8629 2.74492 18.0009 2.93954 18.0009 3.16208V7.83622Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMosaicIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mosaicIcon.5fdab81751e328b7476e5025dd111b66.svg";